import { Route, Switch } from 'react-router-dom';

import { Automation, AutomationsIndex, AutomationWizard } from './pages';

export const AutomationRoutes = () => (
  <Switch>
    <Route path="/settings/automations" exact>
      <AutomationsIndex />
    </Route>
    <Route path="/settings/automations/new" exact>
      <AutomationWizard />
    </Route>
    <Route path="/settings/automations/edit" exact>
      <AutomationWizard />
    </Route>
    <Route path="/settings/automations/:id" exact>
      <Automation />
    </Route>
    <Route path="/settings/automations/:id/edit" exact>
      <AutomationWizard />
    </Route>
  </Switch>
);
